
import { CSSProperties } from "@mui/material";

export const DialogTitleStyle  : CSSProperties = {
    backgroundColor: '#0A192D',
    fontSize: 22,
    color: 'white',
}

export const DialogContentStyle  : CSSProperties = {
    backgroundColor: '#fff',
}

export const DialogActionsStyle  : CSSProperties = {
    backgroundColor: '#fff',
}